import { render, staticRenderFns } from "./RichTextPopup.vue?vue&type=template&id=7625d2c6"
import script from "./RichTextPopup.vue?vue&type=script&lang=js"
export * from "./RichTextPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports